import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Select,
  Collapse,
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";

const FirmListTableFilter = (props) => {
  const [form] = Form.useForm();

  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onFirmSeach = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Firm?$select=id,firmBranchNumber,name&$filter=(${odata.contains("name", value)} or ${odata.contains("firmBranchNumber", value)}) and Name ne 'Diğer'`
      ).then((res) => {
        setFirmSelect({ data: [{ id: `_${value}`, firmBranchNumber: "", name: `'${value}' içerenleri ara` }].concat(res.value), loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };
  
  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];

      if (values.id) {
        if (values.id.startsWith("_")) {
          const searchValue = values.id.slice(1);
          conditions.push(`(${odata.contains("name", searchValue)} or ${odata.contains("firmBranchNumber", searchValue)})`);
        } else {
          conditions.push(`id eq ${values.id}`);
        }
      }

      if (values.firmBranchNumber) {
        conditions.push(odata.contains("firmBranchNumber", values.firmBranchNumber));
      }

      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }
      if (props.onFinishFilter) props.onFinishFilter(query);
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };
const ScreenNameWithActiveTab = () => {
    switch (props.activeTab) {
      case "1":
        return "Cari";
      case "2":
        return "Banka";
      case "3":
        return "Masraf";
      case "4":
        return "Çek";
      case "5":
        return "Senet";
    }
  }
  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="id" label={`${ScreenNameWithActiveTab()} :`} >
                    <Select
                      allowClear
                      showSearch
                      style={{ width: "100%" }}
                      dropdownStyle={{ minWidth: "50%" }}
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onFirmSeach}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={firmSelect.loading}
                    >
                      {firmSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.firmBranchNumber}
                        >
                          {`${item.name} ${(item.firmBranchNumber?`(${item.firmBranchNumber})`:'')}`}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="firmBranchNumber" label={`${ScreenNameWithActiveTab()} Kodu :`}>
                    <Input allowClear />
                  </Form.Item>
                </Col>

              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>

            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default FirmListTableFilter;